<div class="card mx-2 mt-3 flex flex-col !shadow-sm xl:ml-6 xl:mr-[60px]">
  @for (banner of banners(); track banner; let index = $index) {
    <div data-cy="banner" class="flex flex-col">
      <div class="flex items-center gap-2 bg-surface p-3 pr-2">
        <mat-icon class="material-icons-outlined !size-4 flex-shrink-0 text-banner-text" style="font-size: 16px">
          info
        </mat-icon>

        <span class="text-xs font-semibold text-banner-text xl:text-sm"> {{ banner.title }} </span>

        @if (banner.disableClose) {
          <div class="size-5"></div>
        } @else {
          <button mat-icon-button (click)="onCloseBanner(index)" id="banner-close-btn" class="ml-auto">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>

      <div class="px-4 pb-4 pt-3">
        @if (banner.message) {
          <span class="text-sm text-banner-text">
            {{ banner.message }}
          </span>
        }
        @if (banner.templateRef) {
          <ng-container *ngTemplateOutlet="banner.templateRef" />
        }
      </div>
    </div>
  }
</div>
